type StringKeyOf<T extends object> = Extract<keyof T, string>;

type Entry<T extends object> = {
  [K in StringKeyOf<T>]-?: [K, T[K]];
}[StringKeyOf<T>];

export function typedKeys<T extends object>(object: T): StringKeyOf<T>[] {
  return Object.keys(object) as StringKeyOf<T>[];
}

export function typedEntries<T extends object>(object: T): Entry<T>[] {
  return Object.entries(object) as Entry<T>[];
}
